const initialState = 'ENGLISH';

const languageReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SELECT_LANGUAGE':
                  return action.language;
            default:
                  break;
      }
      return state;
};
export default languageReducer;